// How a picture sits in its tile (Ravi, 28 Sep: "when people see the video on a mobile screen, it cuts the frame").
// Zoom, Meet and Teams show the WHOLE frame in the main view and let the tile's own colour fill the rest; a face is
// never cropped to fill a cell. Pure, so it is tested without a browser: the call gives it the space and the
// picture's size and lays the tile out from the answer.

// The largest box of the picture's shape that fits the space, centred. Sizes in CSS pixels; a picture whose size is
// not known yet takes the whole space (the tile then shows the initials or the first frame, contained).
export function fitInside({ width, height, videoWidth = 0, videoHeight = 0 }) {
  const W = Math.max(0, width), H = Math.max(0, height);
  if (!(videoWidth > 0 && videoHeight > 0) || !W || !H) return { width: W, height: H, left: 0, top: 0 };
  const ar = videoWidth / videoHeight;
  let w = W, h = Math.round(W / ar);
  if (h > H) { h = H; w = Math.round(H * ar); }
  return { width: w, height: h, left: Math.round((W - w) / 2), top: Math.round((H - h) / 2) };
}

// A phone held upright sends a picture taller than it is wide: in a landscape cell it must be contained, not cropped.
export function isPortrait({ videoWidth = 0, videoHeight = 0 }) {
  return videoWidth > 0 && videoHeight > videoWidth;
}
